import {trackEvent} from '@hconnect/common/logging/Analytics'
import {useRequiredUser} from '@hconnect/login'
import {useUpmPlantContext} from '@hconnect/upm'
import {useCallback} from 'react'

const OPTIMIZER_EVENTS = ['onViewOptimizedPlan', 'onAcceptOptimizedPlan'] as const

type OptimizerEventName = (typeof OPTIMIZER_EVENTS)[number]

type PlannerEvent = {
  name: OptimizerEventName
  [key: string]: unknown
}

export const useTrackPlannerEvent = () => {
  const {plantId, country, name: plantName} = useUpmPlantContext()
  const {user_id: userId} = useRequiredUser()

  return useCallback(
    ({name, ...otherEventProps}: PlannerEvent) =>
      trackEvent(name, {
        product: 'planner',
        plantId,
        plantName,
        country,
        userId,
        feature: 'Optimizer',
        ...otherEventProps
      }),
    [country, plantId, plantName, userId]
  )
}
